import { createContext } from "react";
import LiveEventMenuViewStore from "@state/stores/offer/live/LiveEventMenuViewStore";

export const LiveEventSideMenuContext = createContext<LiveEventMenuViewStore>(
	{} as LiveEventMenuViewStore
);
